var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-\\u2013-Assets-and-styles",
    transform: "translate(-1191.000000, -943.000000)",
    fill: "#62A9A9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout-icon",
    transform: "translate(1191.000000, 943.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "0 -0.00015 0 11.99985 10.1818182 11.99985 10.1818182 10.500225 1.46 10.500225 1.46 1.500225 10.1818182 1.500225 10.1818182 -0.00015"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "2.90909091 6.75 10.1818182 6.75 10.1818182 4.875 2.90909091 4.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "8.0157152 4.10221503 9.73989737 5.81202924 8 7.51556659 9.13438101 8.625 12 5.81924761 9.15715202 3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6b64d2e306f3d0398090a5f71c8d89b2.svg";
export { ForwardRef as ReactComponent };